import { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import styles from './ProductImageTooltip.module.css';

import iconeGringao from '../../assets/iconegringao.png';

const ProductImageTooltip = ({ codigo, children, tipo = 'loja-fisica' }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  // Buscar URL da imagem quando o tooltip abrir
  useEffect(() => {
    if (showTooltip && !imageUrl && !imageError) {
      const fetchImageUrl = async () => {
        try {
          const endpoint = tipo === 'ecommerce'
            ? `/api/produtos/ecommerce/${codigo}/imagem?t=${Date.now()}`
            : `/api/produtos/loja-fisica/${codigo}/imagem?t=${Date.now()}`;

          const response = await api.get(endpoint);

          if (response.data.success && response.data.url) {
            setImageUrl(response.data.url);
          } else {
            throw new Error('URL não encontrada');
          }
        } catch (error) {
          console.error(`Erro ao buscar URL da imagem: ${codigo}`, error);
          setImageError(true);
        }
      };

      fetchImageUrl();
    }
  }, [showTooltip, codigo, tipo, imageUrl, imageError]);

  const calculatePosition = useCallback((e) => {
    const tooltipWidth = 240;
    const tooltipHeight = 280;
    const margin = 15;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const rect = e.currentTarget.getBoundingClientRect();

    // Tentar posicionar à direita do elemento
    let left = rect.right + 15;
    let top = rect.top + (rect.height / 2) - (tooltipHeight / 2);

    // Se sair pela direita, mostra à esquerda
    if (left + tooltipWidth > windowWidth - margin) {
      left = rect.left - tooltipWidth - 15;
    }

    // Se sair pela esquerda também, centraliza
    if (left < margin) {
      left = margin;
    }

    // Se sair pelo topo
    if (top < margin) {
      top = margin;
    }

    // Se sair por baixo
    if (top + tooltipHeight > windowHeight - margin) {
      top = windowHeight - tooltipHeight - margin;
    }

    setPosition({ top, left });
  }, []);

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  const handleMouseEnter = (e) => {
    calculatePosition(e);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
    setImageError(false);
    setImageLoaded(false);
    setImageUrl(null);
  };

  return (
    <div
      className={styles.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}

      {showTooltip && (
        <div
          className={styles.tooltip}
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`
          }}
        >
          {!imageError ? (
            <>
              {!imageUrl && (
                <div className={styles.loading}>
                  <div className={styles.spinner}></div>
                  <p>Carregando...</p>
                </div>
              )}
              {imageUrl && (
                <>
                  {!imageLoaded && (
                    <div className={styles.loading}>
                      <div className={styles.spinner}></div>
                      <p>Carregando imagem...</p>
                    </div>
                  )}
                  <img
                    src={imageUrl}
                    alt={`Produto ${codigo}`}
                    className={styles.image}
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                    style={{ display: imageLoaded ? 'block' : 'none' }}
                  />
                  {imageLoaded && <div className={styles.codigo}>{codigo}</div>}
                </>
              )}
            </>
          ) : (
            <div className={styles.noImage}>
              <img src={iconeGringao} alt="Sem imagem" className={styles.noImageIcon} />
              <p className={styles.noImageText}>Sem imagem</p>
              <div className={styles.codigo}>{codigo}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductImageTooltip;
